<div class="search-container">
  <i class="dx-icon dx-icon-search search-icon" (click)="searchVisible = !searchVisible"></i>
  <div class="search-component" *ngIf="searchVisible">
    <div>
      <div>Find</div>
      <dx-text-box class="gpd-input" [(value)]="searchText" (onValueChanged)="onSearchChange($event)"
        valueChangeEvent="keyup"></dx-text-box>
    </div>
    <div>
      <dx-button class="btn-inverted" text="Back" (onClick)="onPrevMatch()"
        [disabled]="matches.length == 0"></dx-button>
      <dx-button class="btn-inverted" text="Next" (onClick)="onNextMatch()"
        [disabled]="matches.length == 0"></dx-button>
    </div>
    <div>
      {{(matchIndex ?? -1) + 1 }} of {{matches.length}} matches
    </div>
  </div>
</div>